import { CartView } from '../types/cartTypes';
import { getCart as getCartUtil } from '../utils/cartUtil';

export async function getCart(): Promise<CartView | null> {
  try {
    const cart = await getCartUtil();
    return cart;
  } catch (error) {
    console.error('[getCart] Failed to fetch cart:', error);
    return null;
  }
}
